
import Vue from "vue";
import dayjs from "dayjs";
import TableCustom from "@/components/TableCustom.vue";
import colorStatus from "@/common/mixins/colorStatus";
import NoDataAvailable from "@/components/NoDataAvailable.vue";
import LoadingGraph from "@/components/LoadingGraph.vue";

export default Vue.extend({
  name: "DischargeMca",
  mixins: [colorStatus],
  components: { TableCustom, NoDataAvailable, LoadingGraph },
  computed: {
    companyId(): any {
      return this.$store.getters.company.id || 0;
    },
    modelId(): any {
      return this.$store.getters.model.id || 0;
    },
    modelCode(): any {
      return this.$store.getters.model.modelCode || "";
    },
    graphInformationTabSecondaryId(): any {
      return this.$store.getters.graphInformationTab.is_secondary_tab?.id || 0;
    },
    secondaryTabId() {
      return this.$store.state.graphInformationTab.is_secondary_tab?.id || 0;
    },
  },
  data() {
    let datas = [];
    let headersOverall = [];
    let overallStatus = -1;

    headersOverall = [
      { text: "Status", value: "sensorStatus", width: "5%", sortable: false },
      { text: "Name", value: "sensorName", width: "35%", sortable: false },
      { text: "Amplitude (mV)", value: "value", width: "10%", sortable: false },
    ];

    return {
      timestamp: null,
      datas: [],
      headersOverall,
      overallStatus,
      chartLoading: true,
    };
  },
  methods: {
    async fetchOverallModel() {
      try {
        this.chartLoading = true;

        if (!this.modelCode) {
          this.chartLoading = false;
          return;
        }

        const res = await Vue.prototype.$dep.modelUseCase.getDischargeMca(this.modelCode, this.modelId, this.secondaryTabId);
        this.timestamp = res.time;
        this.datas = res.tag;
      } catch (error) {
        console.error(error);
      } finally {
        this.chartLoading = false;
      }
    },
    colorStatus(status: number) {
      if (status === 0) {
        return "normal";
      } else if (status === 1) {
        return "warning";
      } else if (status === 2) {
        return "alarm";
      } else if (status === -1) {
        return "offline";
      } else {
        return "disabled";
      }
    },
    statusCode(status: number) {
      if (status === 2) {
        return "#f44336";
      } else if (status === 1) {
        return "#ffc12b";
      } else if (status === 0) {
        return "#4caf50";
      } else if (status === -1) {
        return "#00000000";
      } else {
        return "#808080";
      }
    },
    handleOpenMenu(id: any) {
      this.$router.push({ name: "ViewModelPage", params: { id } });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    formatDate(date: any) {
      return dayjs(date).format("dddd, DD MMMM YYYY HH:mm");
    },
  },
  watch: {
    async secondaryTabId() {
      await this.fetchOverallModel();
    },
  },
});
